/*
	import { updateRecurringEvent } from '@/services/CalendarEvent/CommunityCalendarRecurringEvent/Put';

  const { result, successful, message } = await updateRecurringEvent ({
    json: {}
  });
  if (!successful) {
    console.error (message);
    return;
  }
*/

import kms from '@/services/kms'

export async function updateRecurringEvent({ json }) {
  let message = 'The event could not be updated successfully.'

  try {
    const result = await kms.put(`/CalendarEvent/CommunityCalendarRecurringEvent`, json)

    return {
      successful: true,
      message,
      result
    }
  } catch (exception) {
    console.error(exception)
  }

  return {
    successful: false,
    message,
    result: {}
  }
}
